"use client";

import dynamic from "next/dynamic";

const Scene = dynamic(() => import("@/components/storefront/site-3d-background").then((mod) => mod.Site3DBackground), { ssr: false });

export function Site3DMount() {
  return (
    <div className="pointer-events-none fixed inset-0 z-0" aria-hidden>
      <Scene />
    </div>
  );
}
